// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__13YHh","modalForm":"UpgradeEpcsModal_modalForm__1wjtl","modalFooter":"UpgradeEpcsModal_modalFooter__3lt7E"};